// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"5b4fa006","977":"1e5b44d8"}[chunkId] + ".chunk.js";
};